import {axios, API, LANGUAGES, BASE} from '../../config'
import {mobileMenuClose} from './screen'
//import sizeof from '../lib/sizeof'

const types = {
	
	SET_LANGUAGE: 'SET_LANGUAGE',
	SET_LOCATION: 'SET_LOCATION',
	LOCATION_LOADED: 'LOCATION_LOADED',
	OPEN_PATH: 'OPEN_PATH',


	FIND_QUERY: 'FIND_QUERY',
	FIND_RESULTS: 'FIND_RESULTS',
	CLAIM: 'CLAIM',
	RELEASE: 'RELEASE',
	RELEASE_ALL: 'RELEASE_ALL',
	REQUEST_DATA: 'REQUEST_DATA',
	RECEIVE_DATA: 'RECEIVE_DATA',
	RECEIVE_CACHED: 'RECEIVE_CACHED',
	REQUEST_VIEW: 'REQUEST_VIEW',
	RECEIVE_VIEW: 'RECEIVE_VIEW',
	CLEAR_VIEWS: 'CLEAR_VIEWS',
	REQUEST_HOME: 'REQUEST_HOME',
	RECEIVE_HOME: 'RECEIVE_HOME',
	REQUEST_STRINGS: 'REQUEST_STRINGS',
	RECEIVE_STRINGS: 'RECEIVE_STRINGS',
	OPEN_PRODUCTS: 'OPEN_PRODUCTS',
	CLOSE_PRODUCTS: 'CLOSE_PRODUCTS',
	SENDING_FORM: 'SENDING_FORM',
	FORM_SENT: 'FORM_SENT',
	ERROR: 'ERROR',
	CLEAR_ERROR: 'CLEAR_ERROR',
	
	TOGGLE: 'TOGGLE',
	TOGGLE_OVERLAY: 'TOGGLE_OVERLAY',
	CLOSE_OVERLAYS: 'CLOSE_OVERLAYS',
};

let initialState = {
	location: null,
	loading: false,
	loadingLocation: false,
	forms: {},
	sendingForm: false,
	uid: 0,
	claims: {},
	isHome: false,
	views: {},
	error: null,
	tags: {},
	node: null,
	props: {},
	overlay: {},
}
if (LANGUAGES && LANGUAGES.length>0) initialState.lang = LANGUAGES[0]

export default function pageReducer(state = initialState, action) {
   	//console.log(action);
   	//console.log(state)
   	//console.log(sizeof(state))
   	switch(action.type) {
		case types.SET_LANGUAGE:
			if (state.lang === action.lang) return state
			return Object.assign({}, state, { lang: action.lang })
		case types.OPEN_PATH:
			return Object.assign({}, state, {
        		path: action.path,
        		productsView: false,
        		...action.data
      		});
      		/*
		case types.REQUEST_DATA:
			return Object.assign({}, state, {
        		loading: true,
        		loadingLocation: action.data
      		});*/
		case types.FIND_QUERY: 
			return Object.assign({}, state, {
        		loading: true,
      		});
		case types.FIND_RESULTS: {
			let data = Object.assign({}, state[action.tag], {...action.data})
			let node = state.node
			if(action.tag === state.location) {
				if(data.data && data.data.length>0) node = data.data[0]
				else node = null
			}
			
			return Object.assign({}, state, {
				loading: false,
				[action.tag]: {
					...data,
				},
				node,
				tags: Object.assign({}, state.tags, {[action.tag]: true})
      		});
		}
		case types.CLAIM: {
			let claims = Object.assign({}, state.claims, {
				[action.tag]: state.claims[action.tag]?(state.claims[action.tag]+1):1
			})
			return Object.assign({}, state, {claims});
	}
	case types.RELEASE: {
			let _use = state.claims[action.tag]?(state.claims[action.tag]-1):0
			let claims = Object.assign({}, state.claims, {[action.tag]: _use})
			if(_use===0) {
				return Object.assign({}, state, {
					[action.tag]: null,
					claims
      			});
			}
			return Object.assign({}, state, {
				claims
    		});
	}
	case types.RELEASE_ALL: {
		let newState = {...state}
		Object.keys(state.tags).forEach(tag => delete newState[tag])
		return Object.assign({}, newState, {tags: {}})
	}
		case types.SET_LOCATION:
			if (state.location===action.location) return state
			return Object.assign({}, state, {
        		location: action.location,
        		loadingLocation: true
        		})
        		
		case types.LOCATION_LOADED:
    		return Object.assign({}, state, {loadingLocation: false})
    	case types.SENDING_FORM:
    		return Object.assign({}, state, {sendingForm: true})
    	case types.FORM_SENT:
    		return Object.assign({}, state, {sendingForm: false})
    	case types.ERROR:
    		return Object.assign({}, state, {error: action.data, loading: false})
    	case types.CLEAR_ERROR:
    		return Object.assign({}, state, {error: null})
		case types.TOGGLE: {
			const c = state.props[action.prop] && state.props[action.prop].state
			const newProps = Object.assign({}, state.props, {[action.prop]: {state: !c, data: action.data}})
			return Object.assign({}, state, {props: newProps});
		}
		case types.TOGGLE_OVERLAY: {
			const c = state.overlay[action.ov] && state.overlay[action.ov].state
			const newOverlays = Object.assign({}, state.overlay, {[action.ov]: {state: !c, data: action.data}})
			if (Object.keys(newOverlays).filter(ov => newOverlays[ov].state).length>0) document.body.classList.add('overlay')
			else document.body.classList.remove('overlay')
			return Object.assign({}, state, {overlay: newOverlays});
		}
		case types.CLOSE_OVERLAYS: {
			document.body.classList.remove('overlay')
			return Object.assign({}, state, {overlay: {}})
		}
		default:
			return state;
	}
}

export const actions = {
	
	findQuery: () => ({type: types.FIND_QUERY}),
	findResults: (tag, data) => ({type: types.FIND_RESULTS, tag, data}),
	claim: (tag) => ({type: types.CLAIM, tag}),
	release: (tag) => ({type: types.RELEASE, tag}),
	releaseAll: () => ({type: types.RELEASE_ALL}),

	setLocation: location => ({type: types.SET_LOCATION, location}),
	locationLoaded: () => ({type: types.LOCATION_LOADED}),
	sendForm: (data) => ({ type: types.SEND_FORM, data }),
	sentForm: (data, responseData) => ({ type: types.SENT_FORM, data, responseData }),
	error: (data) => ({ type: types.ERROR, data }),
};

const release = tag => dispatch => dispatch(actions.release(tag))
/*
const release = tag => dispatch => {
	return setTimeout(() => {dispatch(actions.release(tag))}, 1000)
}
*/
const claim = tag => dispatch => dispatch(actions.claim(tag))

let cache = {}
const find = (tag, options={}, refresh=false, cb=null) => (dispatch, getState) => {
	let findOptions = options
	if(LANGUAGES && !options.nofilter) findOptions = Object.assign({lang: getState().page.lang}, options)
	let key = JSON.stringify(findOptions)
	if(cache[key] && cache[key]==='loading') return
		
	if (!refresh && cache[key]) {
		if (getState().page.location === tag) dispatch(actions.locationLoaded())
		return dispatch(actions.findResults(tag, {options: findOptions, data: cache[key].results, total: cache[key].total}))
	}
		
	let collection = options?(options.collection?options.collection:'node'):'node'
	cache[key] = 'loading'
	dispatch(actions.findQuery())
	return axios.get(`${API}/data/${collection}`, {
			params: {options: findOptions}
		})
		.then(response => {
			if (getState().page.location === tag) {
				dispatch(actions.locationLoaded())
				while(Object.keys(cache).length>10) delete cache[Object.keys(cache)[0]]
			}
			cache[key] = response.data
			if(cb) cb(response.data)
			dispatch(actions.findResults(tag, {options: findOptions, data: response.data.results, total:response.data.total}))
		})
		.catch(error => {
		    //eslint-disable-next-line
		    Bugsnag.notifyException(error)
			if (getState().page.location === tag) dispatch(actions.locationLoaded())
			console.log(error);
			dispatch(actions.error(error))})
}

const setLanguage = lang => ({type: types.SET_LANGUAGE, lang})
const fetchLocation = (location, refresh=false) => (dispatch, getState) => {
	dispatch(mobileMenuClose())
	const toks = location.split('/')
	let lang = null
	let field = 'path'
	if (LANGUAGES) {
		lang = 'ro'
		field = 'path.p'
		if(toks.length>=2 && LANGUAGES && LANGUAGES.includes(toks[1])) {
			lang = toks[1]
		}
		if (lang !== getState().page.lang) dispatch(setLanguage(lang))
	}
	dispatch(actions.setLocation(location))
	dispatch(find(location, {collection: 'node', query: {'$or':[{[field]: location}, {alias: location}]}, lang}, false))
}

const refresh = (tag=null) => (dispatch, getState) => {
	let state = getState()
	cache = {}
	if(tag && state.page[tag]) return dispatch(find(tag, state.page[tag].options, true))
		
	let tags = Object.keys(state.page.tags)
	tags.forEach(tag => {
		if(state.page[tag]) dispatch(find(tag, state.page[tag].options, true))
	})
}

const clearCache = () => {
	cache = {}
}

const refreshPage = () => (dispatch, getState) => {
	//let state = getState()
	//dispatch(find(state.page.location, state.page[state.page.location].options, true))
	return dispatch(refresh())
}
const clearError = () => ({ type: types.CLEAR_ERROR })

const getCached = (options={}, cb) => {
		let key = JSON.stringify(options)
		if(cache[key]) return cache[key]
		
		let collection = options?(options.collection?options.collection:'node'):'node'
		cache[key] = 'loading'
		return axios.get(`${API}/data/${collection}`, {
				params: {
					options
				}
			})
			.then(response => {
				cache[key] = response.data
				cb({options, data: response.data.results, total:response.data.total})
			})
			.catch(error => {
			    //eslint-disable-next-line
			    Bugsnag.notifyException(error)
			    console.log(error);})
}
const sendingForm = () => ({type: types.SENDING_FORM})
const formSent = () => ({type: types.FORM_SENT})
const showError = error => (dispatch, getState) => {
	dispatch(actions.error(error))
}
const sendForm = (form, cb=null) => (dispatch, getState) => {
	const state = getState()
	form.url = BASE + state.page.location
	form.lang = state.page.lang
		dispatch(sendingForm())
		return axios.post(`${API}/form`, form)
			.then(response => {
				//console.log(response)
				if(cb) cb(response)
				dispatch(formSent())
			})
			.catch(error => {
			    //eslint-disable-next-line
			    Bugsnag.notifyException(error)
			    dispatch(actions.error(error))
			})
}
const changeLanguage = lang => (dispatch, getState) => {
	if (getState().page.lang === lang) return
	dispatch(setLanguage(lang))
	return dispatch(refresh())
}
const toggle = (prop, data=null) => ({type: types.TOGGLE, prop, data})
const toggleOverlay = (ov, data=null) => ({type: types.TOGGLE_OVERLAY, ov, data})
const closeOverlays = () => ({type: types.CLOSE_OVERLAYS})

export {
	claim,
	release,
	refresh, 
	refreshPage, 
	fetchLocation, 
	clearError, 
	getCached, 
	find, 
	clearCache, 
	sendForm, 
	showError, 
	changeLanguage,
	toggle,
	toggleOverlay, closeOverlays
}


// WEBPACK FOOTER //
// ./src/fm/reducers/page.js